import {
  IGroupedWaitingRoom,
  IWaitingRoom,
  IWaitingRoomCondition,
  IWaitingRoomsGroup,
} from "src/Pages/Company/Pending/PendingBenefits/types";

export const getAllProducts = (item: IGroupedWaitingRoom) => [
  ...item.singleWaitingRooms,
  ...(item.waitingRoomsGroup?.waitingRooms || []),
];
export const getConditionsIds = (
  conditions: IWaitingRoomCondition[]
): string[] =>
  conditions
    .map((condition) => condition.id)
    .filter((id): id is string => Boolean(id));

export const getFilteredAcceptableConditions = (
  conditionTypes: string[],
  conditions: IWaitingRoomCondition[]
) =>
  conditions.filter(
    ({ accepted, conditionAcceptable, type }) =>
      conditionTypes.includes(type) && conditionAcceptable && !accepted
  );

export const handleSalaryDeductionMap = (
  group: IWaitingRoomsGroup,
  value: boolean,
  salaryDeductionMap: Map<string, boolean>
) => {
  if (value) {
    salaryDeductionMap.set(
      group.groupId,
      !group.salaryDeductionAccepted && group.documentActive
    );
  } else {
    salaryDeductionMap.delete(group.groupId);
  }
};
export const handleWaitingRoomsMap = (
  row: IGroupedWaitingRoom,
  value: boolean,
  waitingRoomsMap: Map<string, IWaitingRoom>
) => {
  getAllProducts(row).forEach((item) => {
    if (value) {
      waitingRoomsMap.set(item.id, item);
    } else {
      waitingRoomsMap.delete(item.id);
    }
  });
};

export const countCancellableWaitingRooms = (
  selectedWaitingRooms: Map<IWaitingRoom["id"], IWaitingRoom>
): number =>
  [...selectedWaitingRooms.values()].filter((wr) => wr.cancellable).length;
export const countAcceptableWaitingRooms = (
  selectedWaitingRooms: Map<IWaitingRoom["id"], IWaitingRoom>
): number =>
  [...selectedWaitingRooms.values()]
    .map(
      ({ conditions }) =>
        conditions.filter(
          ({ accepted, conditionAcceptable }) =>
            conditionAcceptable && !accepted
        ).length > 0
    )
    .filter(Boolean).length;

export const getAcceptableDocumentIds = (
  selectedSalaryDeductions: Map<IWaitingRoomsGroup["groupId"], boolean>
): string[] =>
  [...selectedSalaryDeductions.entries()]
    .filter(([, acceptable]) => acceptable)
    .map(([groupId]) => groupId);

export const buildWaitingRoomsPayload = (
  selectedWaitingRooms: Map<IWaitingRoom["id"], IWaitingRoom>,
  conditionTypes: string[]
): { waitingRoomId: string; conditionIds: string[] }[] =>
  Array.from(selectedWaitingRooms, ([waitingRoomId, { conditions }]) => ({
    waitingRoomId,
    conditionIds: getConditionsIds(
      getFilteredAcceptableConditions(conditionTypes, conditions)
    ),
  })).filter((item) => item.conditionIds.length > 0);
